export const iconFontAwesomeMovingBoxOpen = (
	<i className="fa-solid fa-box-open"></i>
);
